import { pageHtml } from './pageHtml';
import { data } from './data';
const html = pageHtml.replace('__DATA_PLACEHOLDER__', JSON.stringify(data));
export function App() {
  return <iframe title="UAE Open Finance — Ecosystem Overview" srcDoc={html} style={{
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    border: 'none'
  }} data-id="element-0" />;
}
export default App;